import { useCallback, useEffect, useRef } from "react";
export var useInputMask = function (_a) {
    var mask = _a.mask, onValueChange = _a.onValueChange;
    var inputRef = useRef(null);
    var currentValueRef = useRef("");
    var setDisplayValue = useCallback(function (value) {
        currentValueRef.current = value;
        if (inputRef.current) {
            inputRef.current.value = value;
        }
    }, []);
    var applyMaskResult = useCallback(function (target, result) {
        target.value = result.value;
        target.setSelectionRange(result.caretPosition, result.caretPosition);
        currentValueRef.current = result.value;
        var unmaskedValue = mask === null || mask === void 0 ? void 0 : mask.getUnmaskedValue(result.value);
        onValueChange(result.value, String(unmaskedValue !== null && unmaskedValue !== void 0 ? unmaskedValue : ""));
    }, [mask, onValueChange]);
    useEffect(function () {
        var input = inputRef.current;
        if (!mask || !input) {
            return;
        }
        var handleBeforeInput = function (event) {
            var _a, _b, _c;
            var target = event.target;
            var selectionStart = (_a = target.selectionStart) !== null && _a !== void 0 ? _a : 0;
            var selectionEnd = (_b = target.selectionEnd) !== null && _b !== void 0 ? _b : 0;
            var inputDirection = "forward";
            if (event.inputType === "deleteContentBackward") {
                inputDirection = "backward";
                if (selectionStart === selectionEnd) {
                    selectionStart = Math.max(selectionStart - 1, 0);
                }
            }
            if (event.inputType === "deleteContentForward" &&
                selectionStart === selectionEnd) {
                selectionEnd += 1;
            }
            var params = {
                prevValue: target.value,
                selectionStart: selectionStart,
                selectionEnd: selectionEnd,
                insertedChars: (_c = event.data) !== null && _c !== void 0 ? _c : null,
                inputDirection: inputDirection,
            };
            var result = mask.processInput(params);
            event.preventDefault();
            applyMaskResult(target, result);
        };
        var handleChange = function (event) {
            var target = event.target;
            var result = mask.processInput({
                prevValue: "",
                insertedChars: target.value,
                selectionStart: 0,
                selectionEnd: 0,
            });
            applyMaskResult(target, result);
        };
        var handleClickOrFocus = function (event) {
            var target = event.target;
            if (target.value === mask.getMaskedValue("")) {
                target.setSelectionRange(0, 0);
            }
        };
        input.addEventListener("beforeinput", handleBeforeInput);
        input.addEventListener("change", handleChange);
        input.addEventListener("click", handleClickOrFocus);
        input.addEventListener("focus", handleClickOrFocus);
        return function () {
            input.removeEventListener("beforeinput", handleBeforeInput);
            input.removeEventListener("change", handleChange);
            input.removeEventListener("click", handleClickOrFocus);
            input.removeEventListener("focus", handleClickOrFocus);
        };
    }, [mask, applyMaskResult]);
    return { inputRef: inputRef, setDisplayValue: setDisplayValue };
};
